export class ShopSettings {
  constructor(http, store) {
    this.http = http;
    this.store = store;
  }

  async getSettingWithKey(key) {
    try {
      const res = await this.http.API_AUTH.$get(
        `shop/setting?SettingKey=${key}`
      );

      if (res.SettingValue) {
        this.store.commit('shop/settings/init', res);
      }
      return res;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
  async stores(
    options = { LanguageIsoCode, Latitude, Longitude, radius: 100 }
  ) {
    try {
      const response = await this.http.API.get('store/locator', {
        params: options,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async getStoreById({ id, LanguageIsoCode }) {
    try {
      const response = await this.http.API.get(
        `store?IdStore=${id}&LanguageIsoCode=${LanguageIsoCode}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async shortLink({ code }) {
    try {
      const response = await this.http.API.get(`shortlink/?Code=${code}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
